import React from 'react';
import { Section } from './Section';
export function HookSection() {
  return <Section className="bg-tactical-gray border-y border-tactical-border" data-id="element-63">
      <div className="max-w-3xl mx-auto text-center" data-id="element-64">
        <p className="text-xl md:text-2xl leading-relaxed text-zinc-300 font-medium" data-id="element-65">
          Tu atención está siendo subastada al mejor postor mientras tu negocio
          se estanca. Cada notificación, cada correo "urgente" y cada pestaña
          abierta es un impuesto que pagas por no tener un sistema de blindaje
          cognitivo.
        </p>
        <div className="w-16 h-1 bg-accent mx-auto mt-6 mb-6" data-id="element-66" />
        <p className="text-lg md:text-xl leading-relaxed text-zinc-400" data-id="element-67">
          Si terminas el día agotado pero con la sensación de que no has
          avanzado nada realmente importante, no tienes un problema de tiempo.{' '}
          <span className="text-white font-semibold" data-id="element-68">
            Tienes un problema de ingeniería de la atención.
          </span>
        </p>
      </div>
    </Section>;
}